const LICENSE_URLS = [
  [/cc0/i, "https://creativecommons.org/publicdomain/zero/1.0/", "CC0"],
  [/pubblico dominio|public domain|\bPDM?\b/i, "https://creativecommons.org/publicdomain/mark/1.0/", "Pubblico dominio"],
  [/cc[\s-]?by[\s-]?sa[\s-]?(\d\.\d)?/i, "https://creativecommons.org/licenses/by-sa/{v}/", "CC BY-SA"],
  [/cc[\s-]?by[\s-]?(\d\.\d)?(?![\s-]?(sa|nc|nd))/i, "https://creativecommons.org/licenses/by/{v}/", "CC BY"],
  [/pexels/i, "https://www.pexels.com/it-it/license/", "Licenza Pexels"],
  [/unsplash/i, "https://unsplash.com/license", "Licenza Unsplash"],
];

export function licenseLink(credit) {
  for (const [re, url, label] of LICENSE_URLS) {
    const m = (credit || "").match(re);
    if (m) return { url: url.replace("{v}", m[1] || "4.0"), label };
  }
  return null;
}

export function ImageCredit({ credit, original, className = "", testid = "image-credit" }) {
  if (!credit) return null;
  const lic = licenseLink(credit);
  const link = "underline decoration-stone-300 hover:text-stone-700 transition-colors";
  return (
    <p className={`font-meta text-[10px] text-stone-400 ${className}`} data-testid={testid}>
      {credit}
      {lic && <> · <a href={lic.url} target="_blank" rel="noopener noreferrer license" className={link} data-testid="image-license-link">testo della licenza</a></>}
      {original?.startsWith("http") && <> · <a href={original} target="_blank" rel="noopener noreferrer" className={link} data-testid="image-original-link">originale</a></>}
    </p>
  );
}
